import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#92B1DD',
  gradientStop2 = '#5E6F8C',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const transformOrigin = '23.52 7.2'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M45.5102 4.20996C41.1702 -1.27004 25.5202 2.42993 23.5202 2.42993C21.5202 2.42993 5.87023 -1.27004 1.53023 4.20996C1.53023 4.20996 0.880192 8.24992 3.93019 10.5399C6.98019 12.8299 17.2402 15.5599 19.0902 13.1599C20.9102 10.7999 21.2102 6.40991 23.5202 6.40991C25.8302 6.40991 26.1302 10.7999 27.9502 13.1599C29.8002 15.5599 40.0602 12.8299 43.1102 10.5399C46.1602 8.24992 45.5102 4.20996 45.5102 4.20996Z"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M46.6002 2.7899C40.8202 -0.590102 33.6202 0.169966 29.9102 0.609966C26.8002 0.979966 24.1602 1.04991 23.4702 1.04991C22.7702 1.04991 20.2302 0.979966 17.1302 0.609966C13.4202 0.169966 6.2202 -0.590102 0.440196 2.7899C0.440196 2.7899 -0.109777 4.09994 1.53022 4.20994C1.53022 4.20994 3.0602 1.36985 11.1302 1.36985C19.2002 1.36985 21.4402 3.00987 23.4802 3.00987C25.5302 3.00987 27.8402 1.36985 35.9102 1.36985C43.9802 1.36985 45.5102 4.20994 45.5102 4.20994C47.1502 4.09994 46.6002 2.7899 46.6002 2.7899Z"
        fill="#010101"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="23.5161"
          y1="13.703"
          x2="23.5161"
          y2="3.41554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
